__turbopack_context__.v({
  "links": "Footer-module-scss-module__cfIBUq__links",
});
